import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import _ from "lodash";

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreIcon from "@material-ui/icons/MoreVert";
import SubjectIcon from "@material-ui/icons/Subject";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import CircularProgress from "@material-ui/core/CircularProgress";

import * as modalActions from "../../_shared/modal/modalActions";
import { selectProject, selectProjectusers } from "../projectSelectors";
import {
  fetch as fetchProject,
  fetchLatestStatus as fetchLatestStatusAction,
  fetchProjectEmailNotificationHistory,
  fetchRecipients as fetchRecipientsAction,
} from '../projectActions';
import * as projectActions from '../projectActions';
import { STATUS_CODE } from '../../../utilities/statusUtils';

import { ProjectDetailsList } from "./ProjectDetailsList";
import ProjectCloseModalContent from "./ProjectCloseModalContent";
import ProjectLockModalContent from "./ProjectLockModalContent";
import ProjectDropModalContent from "./ProjectDropModalContent";
import ProjectUnLockModalContent from "./ProjectUnLockModalContent";
import ProjectConditionallyCloseModalContent from "./ProjectConditionallyCloseModalContent";
import { ProjectOverviewCard } from "./ProjectOverviewCard";
import * as commentActions from "../../comment/commentActions";
import { adminWeight, plAdminWeight, auditorWeight, getMaxWeight } from "../../../roleaccess/utils";
import { REL_ADMIN, REAL_AU_R } from "../../../roleaccess/adGroups";
import { selectUserRoles } from '../../login/loginSelector';
import styles from "./ProjectOverview.module.scss";
import ProjectAdHocEmailNotification from "./ProjectAdHocEmailNotification";
import ProjectEmailNotificationHistory from "./ProjectEmailNotificationHistory";

import {
  transformProjectDetails,
  transformStoreDetails,
  transformInternalUsersDetails,
  transformExternalUsersDetails,
} from "./transformers";

import CommentsPanel from "../../comment/commentPanel/CommentsPanel";
import Project from "../Project";

const drawerWidth = "37%";

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    "background-color": "#e1edf9",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  paper: {
    //padding: theme.spacing(2),
  },
  floatLeft: {
    float: "left",
  },
  floatNone: {
    float: "none",
    marginBottom: "10px",
  },
  margin: {
    margin: "20px",
  },
  marginBottom: {
    marginBottom: "20px",
  },
  marginTop: {
    marginTop: "20px",
  },
  loadingSpinner: {
    position: "absolute",
    left: "50%",
    top: "6%",
  },
}));

const mapStateToProps = state => ({
  data: selectProject(state),
  users: selectProjectusers(state),
  isLoading:
    _.get(state, "projectDetails.request.loading", false) ||
    _.get(state, "users.request.loading", false),
  userRole: selectUserRoles(state),
  latestStatus: _.get(state, "projectDetails.status.latestStatus", null),
});
const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(modalActions.closeModal),
  openConfirmModal: body => dispatch(modalActions.openModal({ body })),
  fetchProjectComments: closingId => dispatch(commentActions.fetch(closingId)),
  fetchAllCategoryCommentsForProject: closingId =>
    dispatch(commentActions.fetchAllCategoryCommentsForProject(closingId)),
  resetComments: () => dispatch({ type: commentActions.RESET_DATA }),
  fetchProject: closingId => dispatch(fetchProject(closingId)),
  fetchLatestStatus: closingId => dispatch(fetchLatestStatusAction(closingId)),
  fetchRecipients: closingId => dispatch(fetchRecipientsAction(closingId)),
  clearLatestStatus: () => {
    dispatch(projectActions.setLatestStatus(null));
    dispatch(projectActions.statusLoading(false)); // Also reset loading state
  },
  fetchProjectEmailNotificationHistory: closingId => dispatch(fetchProjectEmailNotificationHistory(closingId)),
});

const canEdit = status_code_desc => {
  if (
    _.isUndefined(status_code_desc) ||
    _.isEmpty(status_code_desc) ||
    _.isNull(status_code_desc)
  ) {
    return false;
  } else {
    return !(status_code_desc && /locked/i.test(status_code_desc));
  }
};

export const ProjectOverview = ({
  data,
  users,
  history,
  openConfirmModal,
  fetchProjectComments,
  resetComments,
  fetchAllCategoryCommentsForProject,
  userRole,
  isLoading,
  fetchProject,
  latestStatus,
  fetchLatestStatus,
  fetchRecipients,
  clearLatestStatus,
  fetchProjectEmailNotificationHistory,
  projectID,
}) => {
  const projectDetails = _.get(data, 'projectDetails', {});
  const storeDetails = _.get(data, 'storeDetails', {});
  const isAuditor = userRole && userRole.includes && userRole.includes(REAL_AU_R);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openAdHocEmailModal, setOpenAdHocEmailModal] = useState(false);
  const [openEmailHistoryDrawer, setOpenEmailHistoryDrawer] = useState(false);

  const handleOpenAdHocEmailModal = () => {
    if (projectID) {
      setOpen(false);
      fetchRecipients(projectID);
    }
    setOpenAdHocEmailModal(true);
  };

  const handleOpenEmailHistoryDrawer = () => {
    if (projectID) {
      setOpen(false);
      fetchProjectEmailNotificationHistory(projectID);
    }
    setOpenEmailHistoryDrawer(true);
    handleMenuClose();
  };

  useEffect(() => {
    if (projectID) {
      // Clear old latestStatus before fetching new one
      clearLatestStatus();
      fetchLatestStatus(projectID);
    }
  }, [fetchLatestStatus, clearLatestStatus, fetchProjectEmailNotificationHistory, projectID]);
  //console.log('modified date before transformation ', projectDetails.last_change_ts);
  //const canViewComments = userRole? !userRole.includes(REL_ADMIN) : true;

  function handleDrawerOpen(closingId) {
    fetchProjectComments(closingId);
    fetchAllCategoryCommentsForProject(closingId);
    setOpen(true);
  }

  const onEditDetails = canEdit(projectDetails.status_code_desc)
    ? () => history.push(`/projects/${projectDetails.closing_id}/details/edit`)
    : _.noop;

  const onEditUsers = canEdit(projectDetails.status_code_desc)
    ? () => history.push(`/projects/${projectDetails.closing_id}/users/edit`)
    : _.noop;

  function handleDrawerClose() {
    resetComments();
    setOpen(false);
    fetchProject(projectDetails.closing_id);
  }

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const handleMenuOpen = event => setMenuAnchorEl(event.currentTarget);
  const handleMenuClose = () => setMenuAnchorEl(null);

  const triggerCloseConfirm = () => {
    handleMenuClose();
    openConfirmModal(
      <ProjectCloseModalContent
        projectID={projectDetails.closing_id}
        projectName={projectDetails.closing_name}
        history={history}
        projectOpen={true}
        userRole={userRole}
      />
    );
  };

  const triggerLockConfirm = () => {
    handleMenuClose();
    openConfirmModal(
      <ProjectLockModalContent
        projectID={projectDetails.closing_id}
        projectName={projectDetails.closing_name}
        history={history}
        projectOpen={true}
        userRole={userRole}
      />
    );
  };

  const triggerUnLockConfirm = () => {
    handleMenuClose();
    openConfirmModal(
      <ProjectUnLockModalContent
        projectID={projectDetails.closing_id}
        projectName={projectDetails.closing_name}
        history={history}
        projectOpen={true}
      />
    );
  };

  const triggerDropConfirm = () => {
    handleMenuClose();
    openConfirmModal(
      <ProjectDropModalContent
        projectID={projectDetails.closing_id}
        projectName={projectDetails.closing_name}
        history={history}
        projectOpen={true}
      />
    );
  };

  const triggerConditionallyCloseConfirm = () => {
    handleMenuClose();
    openConfirmModal(
      <ProjectConditionallyCloseModalContent
        projectID={projectDetails.closing_id}
        projectName={projectDetails.closing_name}
        history={history}
        projectOpen={true}
      />
    );
  };

  let editMessageOnProjectOverview = "EDIT";
  let functionOnButtonPress = onEditDetails;

  let showActiveOption = true;
  let showLockOption = true;
  let showCloseOption = true;
  let showConditionallyCloseOption = true;
  let showDropOption = true;

  if (projectDetails.status_code === STATUS_CODE.ACTIVE) {
    showActiveOption = false;
    showLockOption = true;
    showCloseOption = true;
    showConditionallyCloseOption = true;
    showDropOption = true;
  } else if (projectDetails.status_code === STATUS_CODE.LOCKED) {
    editMessageOnProjectOverview = "UNLOCK";
    functionOnButtonPress = triggerUnLockConfirm;
  } else if (projectDetails.status_code === STATUS_CODE.DROPPED) {
    showActiveOption = true;
    showLockOption = true;
    showCloseOption = true;
    showConditionallyCloseOption = true;
    showDropOption = false;
  } else if (projectDetails.status_code === STATUS_CODE.CLOSED) {
    showActiveOption = true;
    showLockOption = true;
    showCloseOption = false;
    showConditionallyCloseOption = true;
    showDropOption = true;
  } else if (projectDetails.status_code === STATUS_CODE.CONDITIONALLY_CLOSED) {
    showActiveOption = true;
    showLockOption = true;
    showCloseOption = true;
    showConditionallyCloseOption = false;
    showDropOption = true;
  }
  const allowedWeights = [adminWeight(), auditorWeight(), plAdminWeight()];
  const canChangeStatus = allowedWeights.includes(getMaxWeight(userRole));
  const canEditProject = allowedWeights.includes(getMaxWeight(userRole));
  const canSendEmailNotification = [auditorWeight()].includes(getMaxWeight(userRole));

  return (
    <>
      <Grid container justify="center" spacing={3}>
        {isLoading && <CircularProgress className={classes.loadingSpinner} />}
        <Grid item xs={12}>
          <header className={styles.header}>
            <div className={styles["flex-center-start-gap-4"]}>
              <SubjectIcon />
              <Typography variant="h5">
                Project Overview
              </Typography>
            </div>
            <div className={styles["flex-center-gap-8"]}>
              {(!isLoading &&
                <div className={styles["flex-center-gap-8"]}>
                  {canSendEmailNotification && (
                    <Button variant='outlined' color="primary" onClick={handleOpenAdHocEmailModal}>
                      Send Email Notification
                    </Button>
                  )}
                  <Button
                    variant='contained'
                    color='primary'
                    className='viewCommentsButton'
                    onClick={() => handleDrawerOpen(projectDetails.closing_id)}
                  >
                    View Comments
                  </Button>
                </div>
              )}
              <Drawer
                className={classes.drawer}
                anchor="right"
                open={open}
                onClose={handleDrawerClose}
                classes={{
                  paper: classes.drawerPaper,
                }}>
                <CommentsPanel
                  isProjectLevel
                  statusCode={projectDetails.status_code}
                />
              </Drawer>
              {projectDetails.status_code !== STATUS_CODE.LOCKED && canChangeStatus && (
                <section>
                  <IconButton aria-label="Project Menu" onClick={handleMenuOpen}>
                    <MoreIcon />
                  </IconButton>
                  <Menu
                    id="project-menu"
                    anchorEl={menuAnchorEl}
                    keepMounted
                    open={Boolean(menuAnchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}>
                    {/* <MenuItem onClick={handleMenuClose}>Share</MenuItem> */}
                    {/* <MenuItem onClick={handleMenuClose}>Print</MenuItem> */}
                    {showActiveOption && (
                      <MenuItem onClick={triggerUnLockConfirm}>Set Active</MenuItem>
                    )}
                    {showLockOption && (
                      <MenuItem onClick={triggerLockConfirm}>Lock</MenuItem>
                    )}
                    {showCloseOption && (
                      <MenuItem onClick={triggerCloseConfirm}>Close</MenuItem>
                    )}
                    {showConditionallyCloseOption && (
                      <MenuItem onClick={triggerConditionallyCloseConfirm}>Conditional Closure</MenuItem>
                    )}
                    {showDropOption && (
                      <MenuItem onClick={triggerDropConfirm}>Drop</MenuItem>
                    )}
                    <MenuItem onClick={handleOpenEmailHistoryDrawer}>Email Notification History</MenuItem>
                  </Menu>
                </section>
              )}
            </div>
          </header>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ProjectOverviewCard
            title="PROJECT DETAILS"
            onEdit={functionOnButtonPress}
            canEditProject={canEditProject}
            editMessage={editMessageOnProjectOverview}
            locked={projectDetails.status_code === STATUS_CODE.LOCKED}>
            <Fragment>
              <section>
                <ProjectDetailsList
                  details={transformProjectDetails(projectDetails)}
                  projectId={projectDetails.closing_id}
                  statusCode={projectDetails.status_code}
                  latestStatus={latestStatus}
                />
              </section>
              <section>
                <ProjectDetailsList
                  title="Store Details"
                  details={transformStoreDetails(storeDetails)}
                  projectId={projectDetails.closing_id}
                  statusCode={projectDetails.status_code}
                  latestStatus={latestStatus}
                />
              </section>
            </Fragment>
          </ProjectOverviewCard>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ProjectOverviewCard title="USERS" onEdit={onEditUsers} canEditProject={canEditProject}>
            <Fragment>
              <section>
                <ProjectDetailsList
                  title="Internal Users"
                  details={transformInternalUsersDetails(
                    users.filter(function (user) {
                      return user.external_user_ind === "0";
                    })
                  )}
                  projectId={projectDetails.closing_id}
                  statusCode={projectDetails.status_code}
                  latestStatus={latestStatus}
                />
              </section>
              <section>
                <ProjectDetailsList
                  title="External Users"
                  details={transformExternalUsersDetails(
                    users.filter(function (user) {
                      return user.external_user_ind === "1";
                    })
                  )}
                  projectId={projectDetails.closing_id}
                  statusCode={projectDetails.status_code}
                  latestStatus={latestStatus}
                />
              </section>
            </Fragment>
          </ProjectOverviewCard>
        </Grid>
      </Grid>
      {openAdHocEmailModal && <ProjectAdHocEmailNotification open={openAdHocEmailModal} onClose={() => setOpenAdHocEmailModal(false)} closing_id={projectID} />}
      {openEmailHistoryDrawer && <ProjectEmailNotificationHistory open={openEmailHistoryDrawer} onClose={() => setOpenEmailHistoryDrawer(false)} />}
    </>
  );
};

ProjectOverview.defaultProps = {
  data: {},
  users: [],
  history: _.noop,
  openConfirmModal: _.noop,
  projectID: null,
};

ProjectOverview.propTypes = {
  data: PropTypes.object,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      role_id: PropTypes.number,
      role_name: PropTypes.string,
      extrn_first_name: PropTypes.string,
      extrn_last_name: PropTypes.string,
    })
  ),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  openConfirmModal: PropTypes.func,
  fetchProjectComments: PropTypes.func.isRequired,
  resetComments: PropTypes.func.isRequired,
  fetchRecipients: PropTypes.func.isRequired,
  fetchAllCategoryCommentsForProject: PropTypes.func.isRequired,
  userRole: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  fetchProject: PropTypes.func.isRequired,
  latestStatus: PropTypes.any,
  fetchLatestStatus: PropTypes.func.isRequired,
  clearLatestStatus: PropTypes.func.isRequired,
  fetchProjectEmailNotificationHistory: PropTypes.func.isRequired,
  projectID: PropTypes.number,
};

const reduxConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectOverview);

export default withRouter(reduxConnected);
